/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import $ from 'jquery';
import _ from 'underscore';
import React from 'react';

import i18n from '../../../../i18n/AdHocBundle.properties';

const ALL_ITEMS_TAB_VALUE = 'all';

export default class TabComponent extends React.Component {

    constructor(props) {
        super(props);

        this.$el = null;
        this.mounted = false;
        this.state = {
            // -1 means the value is unknown
            tabSize: -1,
            isCollapsed: props.initialCollapsedState
        };
    }

    componentDidMount () {
        this.mounted = true;
    }

    componentWillUnmount () {
        this.mounted = false;
    }

    getState() {
        return _.cloneDeep(this.state);
    }

    render() {
        const allGroups = this.props.typeManager.getAllGroups();
        allGroups.unshift({
            name: ALL_ITEMS_TAB_VALUE,
            cssClass: 'jr-mTab-item-iconAll',
            bundleName: 'visualization.chooser.group.all'
        });

        const groupElements = allGroups.map((group) => {
            const classes = ['jr-mTab-item jr'];
            if (this.props.selectedGroup === group.name) {
                classes.push('jr-isActive');
            }
            return (
                <li key={ group.name } onClick={ this._onItemClick.bind(this, group.name) } className={ classes.join(' ') }>
                    <span className="jr-mTab-item-label jr">{ i18n[group.bundleName] }</span>
                    <span className={`jr-mTab-item-icon jr ${group.cssClass}`} />
                </li>
            )
        });

        let panelClass = '';
        let caretClass = 'jr-caretLeft';
        if (this.state.isCollapsed) {
            panelClass = 'jr-isMinimized';
            caretClass = 'jr-caretRight';
        }

        const setElement = (el) => {
            this.$el = $(el);
        };

        return (
            <div ref={setElement} className={`jr jr-mVisualchooser-panel ${panelClass}`}>
                <div className="jr jr-Visualchooser-panel-minimize" onClick={ this._onCollapseClick.bind(this) }>
                    <div className={`jr jr-Visualchooser-panel-minimize-icon jr-mIcon ${caretClass}`} />
                </div>
                <ul className="jr-mTab jr-mTabVertical jr-mTabReverse jr">
                    { groupElements }
                </ul>
            </div>
        );
    }

    _setCollapsed(newCollapsedState) {
        return new Promise((resolve) => {
            this.setState({isCollapsed: newCollapsedState}, () => {
                resolve();
            });
        });
    }

    _onItemClick (selectedGroup) {
        this.props.onGroupChangeCallback(selectedGroup);
    }

    _onCollapseClick () {

        // For the collapse logic we need to know the size of the tab
        // because this value will be used to move the dialog to left or right

        // Important note: this code allows us avoid defining the tab size in CSS, so it can be any size,
        // it's not a constant, as we find its value here

        // so how does this code works ?
        // * it reads the current value of the tab size
        // * it changes its size, in other words, collapses it (or expands)
        // * it reads the new size again, so by his we can figure out the size of the tab
        // * it sends the event to the parent component with the tab size

        const runWithCollapsedState = this.state.isCollapsed;

        let
            tabSize = this.state.tabSize,
            expandedWidth = 0,
            collapsedWidth = 0;

        if (tabSize === -1) {
            if (runWithCollapsedState) {
                collapsedWidth = Math.round(this.$el.outerWidth());
            } else {
                expandedWidth = Math.round(this.$el.outerWidth());
            }
        }

        this._setCollapsed(!runWithCollapsedState).then(() => {

            if (tabSize === -1) {
                // at this stage the tab changed it's size so we need to read the
                // opposite value
                if (runWithCollapsedState) {
                    expandedWidth = Math.round(this.$el.outerWidth());
                } else {
                    collapsedWidth = Math.round(this.$el.outerWidth());
                }

                tabSize = expandedWidth - collapsedWidth;
                if (this.mounted) {
                    this.setState({tabSize});
                }
            }

            this.props.onTabCollapseCallback(this.state.isCollapsed, tabSize);
        });
    }

}
